import React from 'react';
import { Link } from 'react-router-dom';
import Modal from '../../commonComponents/util/Modal';

export default class CheckExistsWarningModal extends React.Component {
    render() {
        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal warning-modal">
                        <h4 className="page-header"><i className="material-icons middle">warning</i>Warning</h4>
                        <div className="medium-text">
                            <span>{this.props.message}</span>
                            <br/>
                            <span className="bold-text">Are you sure you want to proceed?</span>
                        </div>
                        {this.props.transactions.length && <div className="mt-16">
                            <div className="small-text"><span className="bold-text">Assigned Applications</span>{` click on link${this.props.transactions.length > 1 ? 's' : ''} below to view:`}</div>
                            <div className="mt-8">
                            {this.props.transactions.map(t => {
                                let url = `/recipient-accounts/${t.recipientId}?applicationId=${t.applicationId}`;
                            return (<div className=""><Link target={"_blank"} to={url} className="link-text small-text">{url}</Link></div>)
                            })}
                            </div>
                        </div>}
                        <div className="warning-modal-btns text-right">
                            <button className="btn btn-accent" onClick={() => {
                                if (this.props.cancel)
                                    this.props.cancel();
                                this.props.close();
                            }}>{this.props.cancelText || "Cancel"}</button>
                            <button className="btn btn-accent2" onClick={() => {
                                this.props.continue();
                                this.props.close();
                            }}>{this.props.continueText || "Continue"}</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/newApplication/CheckExistsWarningModal.jsx